module.exports = __webpack_public_path__ + "static/media/DocumentFeatures.c8bcba7b.png";